import { MaterialAttributes } from '@albatrosdeveloper/ave-models-package';
import SalesOrganizationAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-organization/sales-organization.entity';
import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { IAPIListResult, IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { SalesOrganizationService } from 'app/modules/components/configuration/sales-organization/sales-organization.component.service';
import { MaterialService } from 'app/modules/components/material/material/material.service';
import { environment } from 'environments/environment.prod';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { MaterialPriceListService } from '../strategy-price-list.service';
import MaterialPriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-price-list/material-price-list.entity';
import { ConditionClassEnum } from '../condition-class-enum';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import AlternalUnitMeasurementAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/materials/material/alternal-unit-measure/alternal-unit-measure.entity';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatMenuModule } from '@angular/material/menu';
import PriceListAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/price-list/price-list.entity';
import { PriceListService } from '../../price-list/price-list.service';
import UnitMeasurementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/unit-measurements/unit-measurements.entity';
import { UnitMeasureService } from '../../unit-of-measurement/unit-of-measurement.service';
import { SequenceReadingService } from '../sequence-reading.service';

@Component({
  selector: 'app-setting-promotion-list',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    NgxMatSelectSearchModule
  ],
  templateUrl: './setting-promotion-list.component.html',
  styleUrl: './setting-promotion-list.component.scss'
})
export class SettingPromotionListComponent {

  displayedColumns: string[] = [
    "field9",
    "materialPromotion",
    "field12", 
    "dateEnd",
    "action"
  ];

  dataSource = new MatTableDataSource<MaterialPriceListAttributes>([])

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof MaterialPriceListAttributes = "dateEnd";
  sortDirection: "ASC" | "DESC" = "ASC";

  //list
  sequence: string = 'S1'
  salesOrganizationList: SalesOrganizationAttributes[] = [];

  priceList: PriceListAttributes[] = [];
  listFilterPriceList: PriceListAttributes[] = []
  searchPriceList = ''

  materialList: MaterialAttributes[] = [];
  searchMaterial = ''
  private searchSubject = new Subject<string>();
  materialListPromotional: MaterialAttributes[] = [];
  searchMaterialPromotional = ''
  private searchSubjectPromotional = new Subject<string>();

  unitMeasureList: AlternalUnitMeasurementAttributes[] = []
  unitMeasurePromotionList: AlternalUnitMeasurementAttributes[] = []

  currentCreatePromotionList: any = this.initializeCreatePromotionList();
  currentUpdatePromotionList: MaterialPriceListAttributes | undefined;

  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  constructor(
    private materialPriceListService: MaterialPriceListService,
    private readonly sequenceReadingService: SequenceReadingService,
    private readonly salesOrganizationService: SalesOrganizationService,
    private readonly priceListService: PriceListService,
    private readonly materialService: MaterialService,
    private readonly unitService: UnitMeasureService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<SettingPromotionListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getSequence()
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getPromotionsList()
  }

  getPromotionsList(){
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }
    let conditionClass = ConditionClassEnum.XG01

    this.materialPriceListService.findAllWithCount(options, this.data.materialId, conditionClass, this.sequence).subscribe({
      next: (res: IPaginationResult<MaterialPriceListAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;

        /* this.dataSource.data.forEach((item: any) =>{
         /* this.getMaterialId(item.field6).then((details) => {
            item.materialDetail = details;
          }); *

          this.getMaterialId(item.field10).then((details) => {
            item.materialPromotion = details;
          });
        })

        this.dataSource.data.forEach((item:any) => {
          this.getUnitMeasureId(item.field7).then((details) => {
            item.unitMeasure = details;
          })

          this.getUnitMeasureId(item.field11).then((details) => {
            item.unitMeasurePromotion = details;
          })
        }) */
      },
      error: (err) => {
        this.dataSource.data = []
        this.snackBar.open(err.error.message || "Error al obtener lista promociones","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction
    this.getPromotionsList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getPromotionsList()
  }

  private getSequence(): void {
    const options = {
      search: null,
      currentPage: 1,
      limitPerPage: 50,
      //sortActive: "name",
      //sortDirection: "ASC"
    };

    this.sequenceReadingService.findAllWithCount(
      options,
      ConditionClassEnum.XG01
    ).subscribe({
      next: (res: IAPIListResult<any>) => {
        if (Array.isArray(res.data) && res.data.length > 0 && Array.isArray(res.data[0]?.sequences) && res.data[0].sequences.length > 0) {
          this.sequence = res.data[0].sequences[0].sequence;
        }
        this.getPromotionsList()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener secuencias.","Cerrar",{ duration: 5000});
      },
    });
  }

  //list
  private initializeCreatePromotionList(): any { //ICreatePromotionList
    return { 
      distributionChainId: "", promotionListId:"", itemId: "", unitMeasureId: "", quantity: null,
      promotionItemId: "", promotionUnitMeasureId: "", promotionQuantity: null,
      dateStart: null, dateEnd: null
    };
  }

  openCreateModal(){
    this.getAllSalesOrganization()
    this.getPriceList()
    this.setupMaterialSearchControl()
    this.setupMaterialPromotionalSearchControl()
    this.getMaterialList()
    this.getMaterialPromotionalList()
    this.dialogRefAdd = this.dialog.open(this.addModal, { width: '90%', disableClose: true })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createPromotionList());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  createPromotionList(){
    const createPriceList: MaterialPriceListAttributes = {
      conditionClass: ConditionClassEnum.XG01,
      sequence: this.sequence,
      field1: this.currentCreatePromotionList.distributionChainId || "", // org venta
      field2: null,
      field3: null,
      field4: this.currentCreatePromotionList.promotionListId || "", // precio promociones
      field5: null, //currency
      field6: this.currentCreatePromotionList.itemId || "", // id material 1
      field7: this.currentCreatePromotionList.unitMeasureId || "", // um 1
      field8: null,
      field9: String(this.currentCreatePromotionList.quantity), // quantity 1
      field10: this.currentCreatePromotionList.promotionItemId || "", // material 2
      field11: this.currentCreatePromotionList.promotionUnitMeasureId, //um 2
      field12: String(this.currentCreatePromotionList.promotionQuantity), //quantity 2
      field13: null,
      dateStart: new Date(this.currentCreatePromotionList.dateStart).toISOString().split('T')[0],
      dateEnd: new Date(this.currentCreatePromotionList.dateEnd).toISOString().split('T')[0],
      price: 0,
      minimumPrice: 0,
      maximumPrice: 0,
      hasScalePrices: false,
      hasMinimumAndMaximunPrices: false,
    };

    this.materialPriceListService.create(createPriceList).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.getPromotionsList()
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openEditModal(settingList: MaterialPriceListAttributes, type): void {
    this.getAllSalesOrganization()
    this.getPriceList()
    this.setupMaterialSearchControl()
    this.setupMaterialPromotionalSearchControl()
    this.getMaterialList()
    this.getMaterialPromotionalList(settingList.field10)

    this.currentUpdatePromotionList = { 
      ...settingList,
    };

    this.dialogRefEdit = this.dialog.open(this.editModal , { width: '90%', disableClose: true })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateMaterialPriceList(settingList._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  updateMaterialPriceList(id){
    let updateMaterialPriceList = {
      ...this.currentUpdatePromotionList,
      field9: String(this.currentUpdatePromotionList.field9), // quantity 1
      field12: String(this.currentUpdatePromotionList.field12), //quantity 2
    }
    this.materialPriceListService.update(id, updateMaterialPriceList).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        this.getPromotionsList();
        this.dialogRefEdit.close();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openDeleteDialog(promotion: any): void {
    this.dialog
      .open(this.deleteDialog, { data: promotion, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(promotion._id.toString()));
  }

  delete(id: string): void {
    this.materialPriceListService.removeList(id).subscribe(() => {
      this.getPromotionsList();
      this.snackBar.open("Registro eliminado con éxito", "Cerrar", {
        duration: 3000,
      });
    });
  }

  //filter
  getMaterialId(id){
    return new Promise((resolve) => {
      this.materialService.findOne(id).subscribe({
        next: (res: IRequestResult<MaterialAttributes>) => resolve(res.data),
        error: (err) => {
          this.snackBar.open(err.error.message || `Error fetching material details for ID ${id}`,"Cerrar",{ duration: 5000});
          resolve(null);
        },
      });
    });
  }

  getUnitMeasureId(id){
    return new Promise((resolve) => {
      this.unitService.findOne(id).subscribe({
        next: (res: IRequestResult<UnitMeasurementsAttributes>) => resolve(res.data),
        error: (err) => {
          this.snackBar.open(err.error.message || `Error fetching unit measure details for ID ${id}`,"Cerrar",{ duration: 5000});
          resolve(null);
        },
      });
    })
  }
  
  //filter form
  private getAllSalesOrganization(): void {
    this.salesOrganizationService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOrganizationList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener organización de ventas.","Cerrar",{ duration: 5000});
      },
    });
  }

  private getPriceList(): void {
    this.priceListService.findToComboBoxPriceList('G').subscribe({
      next: (res: IRequestResult<PriceListAttributes[]>) => {
        this.priceList = res.data;
        this.listFilterPriceList = this.priceList.slice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener listas de precios.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsPriceList(event){
    if (!this.priceList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterPriceList = this.priceList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterPriceList = this.priceList.filter(item => item.name.toLowerCase().indexOf(search) > -1 || item.code.toLowerCase().indexOf(search) > -1)
  }

  private getMaterialList(): void{
    const materialOptions = {
      search: this.searchMaterial ? this.searchMaterial: (this.data.name ? this.data.name : null),
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    const companyCodes = [environment.companyId];
    //const salesOfficeSelected = this.salesOfficesList.find(so => so._id.toString() == this.salesOfficeControl.value)

    this.materialService.findAllComboWithCount(
      materialOptions,
      companyCodes,
      null,
    ).subscribe({
      next: (res: IRequestResult<MaterialAttributes[]>) => {
        this.materialList = res?.data ?? [];
        this.currentCreatePromotionList.itemId = this.data ? this.data.materialId  : ""
        if(this.currentCreatePromotionList.itemId){
          this.getUnitType('N')
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  private getMaterialPromotionalList(promotionItem?): void{
    const materialOptions = {
      search: this.searchMaterialPromotional ? this.searchMaterialPromotional: promotionItem ? null : (this.data.name ? this.data.name : null),
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    const companyCodes = [environment.companyId];

    this.materialService.findAllComboWithCount(
      materialOptions,
      companyCodes,
      promotionItem ? promotionItem : null
    ).subscribe({
      next: (res: IRequestResult<MaterialAttributes[]>) => {
        this.materialListPromotional = res?.data ?? [];
        this.currentCreatePromotionList.promotionItemId = promotionItem ? promotionItem : (this.data ? this.data.materialId  : "")
        if(this.currentCreatePromotionList.promotionItemId){
          this.getUnitType()
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener materiales.","Cerrar",{ duration: 5000});
      },
    })
  }

  changueOptionsMaterial(event){
    this.searchSubject.next(event);
  }

  private setupMaterialSearchControl(): void {
    this.searchSubject
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe((searchTerm) => {
      if(searchTerm){
        this.searchMaterial = searchTerm;
        this.getMaterialList();
      }
    });
  }

  changueOptionsMaterialPromotional(event){
    this.searchSubjectPromotional.next(event)
  }

  private setupMaterialPromotionalSearchControl(): void {
    this.searchSubjectPromotional
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    )
    .subscribe((searchTerm) => {
      if(searchTerm){
        this.searchMaterialPromotional = searchTerm;
        this.getMaterialPromotionalList();
      }
    });
  }

  getUnitType(type?){
    if(type){
      this.getUnitMeasureList(this.materialList,this.unitMeasureList, this.currentCreatePromotionList.itemId)
    }else{
      this.getUnitMeasureList(this.materialListPromotional,this.unitMeasurePromotionList, this.currentCreatePromotionList.promotionItemId)
    }
  }

  getUnitEditType(type?){
    if(type){
      this.getUnitMeasureList(this.materialList,this.unitMeasureList, this.currentUpdatePromotionList.field6)
    }else{
      this.getUnitMeasureList(this.materialListPromotional,this.unitMeasurePromotionList, this.currentUpdatePromotionList.field10)
    }
  }

  getUnitMeasureList(listMaterial, dataList, itemId){
    const selectedItem = listMaterial.find(item => item._id === itemId);

    if(selectedItem){
      if(selectedItem.alternalUnitOfMeasures && selectedItem.alternalUnitOfMeasures.length >= 0){
        const baseUnitFound = selectedItem.alternalUnitOfMeasures.some(um => um.unitOfMeasure._id === selectedItem.baseUnitOfMeasure._id);
  
        // Si no está, agregar baseUnitOfMeasure al inicio
        if (!baseUnitFound) {
          selectedItem.alternalUnitOfMeasures.unshift({
            isUMB: true,
            isUMP: false,
            quantity: 1,
            equivalentQuantity: 1,
            conversionFactor: 1,
            barcode: "",
            price: null,
            unitOfMeasure: {
              _id: selectedItem.baseUnitOfMeasure._id,
              code: selectedItem.baseUnitOfMeasure.code,
              name: selectedItem.baseUnitOfMeasure.name,
              statusId: selectedItem.baseUnitOfMeasure.statusId,
              //_deleted: false
            }
          });
        }
      }else if(selectedItem.baseUnitOfMeasure){
        selectedItem.alternalUnitOfMeasures.unshift({
          isUMB: true,
          isUMP: false,
          quantity: 1,
          equivalentQuantity: 1,
          conversionFactor: 1,
          barcode: "",
          price: null,
          unitOfMeasure: {
            _id: selectedItem.baseUnitOfMeasure._id,
            code: selectedItem.baseUnitOfMeasure.code,
            name: selectedItem.baseUnitOfMeasure.name,
            statusId: selectedItem.baseUnitOfMeasure.statusId,
          }
        });
      }
  
      dataList.length = 0; // Vaciar el arreglo
      dataList.push(...selectedItem.alternalUnitOfMeasures)
    }else{
      dataList.length = 0;
    }
  }
}
